import { IPostInfo } from '@sapientpro/sapientpro-data-models';
import { format } from 'date-fns';
import Link from 'next/link';
import styles from './BlogHead.module.scss';
import AuthorCard from '../AuthorCard';
import AnimatedTitle from '../../../components/AnimatedTitle';
import Img from '../../../components/Img';

const BannerArticle = ({ post }: { post: IPostInfo }) => {
  const formattedDate = format(new Date(post.publishDate), 'dd MMM yyyy');

  return (
    <article className={styles.bannerArticle}>
      <div className={styles.articleDescription}>
        <div className={styles.descriptionHead}>
          <Link
            className={styles.articleCategory}
            href={`/blog/category/${post.category.slug}`}
          >
            {post.category.title}
          </Link>
          <Link
            className={styles.articleTitle}
            href={`/blog/${post.slug}`}
          >
            <h3 className={styles.bannerTitle}><AnimatedTitle title={post.title} /></h3>
          </Link>
        </div>
        <AuthorCard
          avatar={post.author.avatar?.url || ''}
          avatarSize={48}
          name={post.author.pseudonym}
          url={post.author.slug && `/blog/author/${post.author.slug}`}
          info={[formattedDate, `${post.readTime} min read`]}
        />
      </div>
      <Link
        className={styles.imageWrapper}
        href={`/blog/${post.slug}`}
      >
        <Img
          src={post.backgroundImage.url}
          alt={post.backgroundImage.alternativeText || 'banner post image'}
          width={post.backgroundImage.width}
          height={post.backgroundImage.height}
          className={styles.bannerImage}
        />
      </Link>
    </article>
  );
};

export default BannerArticle;
